import React from 'react';
import { connect } from 'react-redux';
import Ax from '../../../components/hoc/Ax';
import AppBaseComponent from '../../../components/AppBaseComponent';
import tapIcon from "../../../services/TapIcon";
import { Modal } from 'bootstrap';
import Loader from '../../../components/ui/Loader/Loader';
import HttpAPICall from "../../../services/HttpAPICall";
import { toast } from 'react-toastify';
import TapApiUrls, { INVENTORY_API_BASE_URL_2 } from '../../../services/TapApiUrls';
import { Link } from 'react-router-dom';
import Status from '../../../components/ui/Status';
import { DisplayListPagination } from '../../../components/TapUi';
import PurchaseDetail from './PurchaseDetail';

class PurchaseItemWiseModal extends AppBaseComponent {
    
    constructor(props) {
        super(props);

        this.state                            =         {
            purchaseDetailList                      :         [],
            purchaseDetailLoading                   :         false,
            itemName                          :         '',
            itemData                          :         null,
            warehouse_id                    :         null,
            listing_tbl_page                  :          1,
            listingMeta                       :          null,
            totalListingCount                 :         0,
            indent_transaction_id              :         ''
        };
        this.poReportUrl      =   INVENTORY_API_BASE_URL_2 + '/report/item-wise-purchase';
    }
    
    
    componentDidMount(){
        this.viewPurchaseHistoryModal             =   new Modal(document.getElementById('viewPurchaseHistoryModal'), {keyboard: false, backdrop :false});
        this.viewTransactionModal              =     new Modal(document.getElementById('viewTransactionModal'), {keyboard: false, backdrop :false});
    }

    modalInit                       =   (data,warehouse_id,indent_transaction_id='')  =>  {
        this.viewPurchaseHistoryModal.show()
            if(data){
                  this.setState({
                    itemData            :        data,
                    warehouse_id        :        warehouse_id ? warehouse_id : null,
                    indent_transaction_id    :       indent_transaction_id,
                  },() => this.fetchPurchaseHistoryData())
            }
    }

    fetchPurchaseHistoryData     =       (page = 1)      =>      {
        this.setState({purchaseDetailLoading : true, purchaseDetailList : [],listing_tbl_page: page});
        let params =  {
                    search_warehouse_ids        :    this.state.warehouse_id !== undefined && this.state.warehouse_id !== null ? [this.state.warehouse_id] : [],
                    search_item_ids             :    this.state.itemData ? [this.state.itemData.id] : null,
                    indent_transaction_id        :     this.state.indent_transaction_id,
                    page                        :    page}
                    
        HttpAPICall.withAthorization('GET', this.poReportUrl, this.props.access_token, {...params}, {}, (resp) => {
            let respData = resp.data;
            this.setState({
                purchaseDetailList          :    respData.data,
                itemName              :    this.state.itemData ? this.state.itemData.name : '',
                listingMeta           :     respData,
                totalListingCount     :     respData.total,
            },()=>  this.viewPurchaseHistoryModal.show())
        
        }).then(() => {
            this.setState({purchaseDetailLoading : false});
        });
    }

    purchaseDetailModalInit          =       (transactionId)           =>      {
       this.setState({
            transactionId :   transactionId
       })  
       this.viewTransactionModal.show()
    }

    transactionDetailsModalJsx                     =   ()  =>  {
        return (
            <div className="modal fade" id="viewTransactionModal" tabIndex="-1">
                <div className="modal-dialog modal-lg modal-dialog-scrollable">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="searchItemModalLabel">Transaction Id : {this.state.transactionId ? this.state.transactionId : "-"}</h5>
                            <button type = "button" className="btn btn-secondary" data-bs-dismiss="modal">Close
                            </button>

                        </div>
                        <div className="modal-body">
                          <PurchaseDetail purchaseId={this.state.transactionId} openedFrom={"indnet"}/>
                            
                        </div>
                    </div>
                </div>
            </div>
        );
    }
    
      purchaseHistoryModalJsx                     =   ()  =>  {
          return (
              <div className="modal fade" id="viewPurchaseHistoryModal" tabIndex="-1">
                  <div className="modal-dialog modal-xl modal-dialog-scrollable">
                      <div className="modal-content  ">
                          <div className="modal-header">
                              <h5 className="modal-title" id="addItemModalLabel">Item Wise Purchase</h5>
                              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                          </div>
                          <div className='p-1 bg-light border-bottom'>
                              <table className='table table-sm mb-0 table-borderless text-sm'>
                                  <tbody>
                                      {this.state.indent_transaction_id ? <tr>
                                          <td style={{ width: "15%" }}> Indent  </td>
                                          <th>{this.state.indent_transaction_id ? this.state.indent_transaction_id : ""}</th>
                                      </tr> : <tr>
                                          <td style={{ width: "15%" }}> Warehouse  </td>
                                          <th>{this.state.purchaseDetailList && this.state.purchaseDetailList.length > 0 && this.state.purchaseDetailList[0]?.warehouse_name ? `${this.state.purchaseDetailList[0]?.warehouse_name}` : "-"}</th>
                                      </tr>}
                                      <tr>
                                          <td style={{ width: "15%" }}> Item  </td>
                                          <th>{this.state.itemName  ?this.state.itemName : "-"}</th>
                                      </tr>

                                  </tbody>
                              </table>
                          </div>
                          <div className="modal-body ">
                              {!this.state.purchaseDetailLoading ?
                                  <table className="table table-bordered  bg-white ">
                                      <thead className="table-secondary">
                                          <tr className="text-end">
                                              <th scope="col" style={{ width: "15%" }} className="text-start">Transaction ID</th>
                                              <th scope="col" style={{ width: "12%" }} className="text-center">Transaction Date</th>
                                              <th scope="col" style={{ width: "15%" }} className="text-start" >Vendor Name</th>
                                              {this.state.indent_transaction_id && <th scope="col" style={{ width: "25%" }} className="text-start" >Warehouse</th> }
                                              <th scope="col" style={{ width: "9%" }}>Qty</th>
                                              <th scope="col" style={{ width: "9%" }}>Rate</th>
                                              <th scope="col" style={{ width: "9%" }}>Amount</th>
                                              <th scope="col" style={{ width: "9%" }} className='text-center'>Status</th>
                                          </tr>
                                      </thead>
                                      <tbody>
                                          {this.state.purchaseDetailList.length > 0
                                              ? (this.state.purchaseDetailList.map((rowData, k) => {
                                                //   return rowData.items.map((rq, rk) => {
                                                      return (<tr key={k}>
                                                          <td><a hred="#" role="button" className='link-primary' onClick={() => this.purchaseDetailModalInit(rowData.transaction_id)}>{rowData.transaction_id}</a></td>
                                                          <td>{rowData.transaction_date_display}</td>
                                                          <td className='text-capitalize'>{rowData.vendor_name}</td>
                                                          {this.state.indent_transaction_id && <td className='text-capitalize'>{rowData.warehouse_name}</td>}
                                                          <td className='text-end'>{rowData.qty}</td>
                                                          <td className='text-end'>{rowData.rate}</td>
                                                          <td className='text-end'>{rowData.qty * rowData.rate}</td>
                                                          <td className='text-center'>{rowData.status && rowData.status.name ? rowData.status.name :  "-"}</td>
                                                          
                                                      </tr>);
                                                //   })
                                              }))
                                              : (<tr><td className="text-center" colSpan={10}>No Record Found</td></tr>)
                                          }
                                      </tbody>
                                  </table>
                                  : <Loader />}
                              <DisplayListPagination
                                  meta={this.state.listingMeta}
                                  onPageChange={(e) => this.fetchPurchaseHistoryData(e.selected + 1)}
                              />
                          </div>
                      </div>
                  </div>
              </div>
          );
    }

    render() {
        return (<Ax>
            {this.purchaseHistoryModalJsx()}
            {this.transactionDetailsModalJsx()}
         
        </Ax>);
    }
}

const mapStateToProps = state => {
    return {
        access_token            :   state.auth.access_token
    };
};

export default connect(mapStateToProps, null, null, { forwardRef: true })(PurchaseItemWiseModal);
